import {IRouletteBet} from "./IRouletteBet";

export class StreetBet implements IRouletteBet {
    constructor(public index: number, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/StreetBet.ts